import React, {useRef} from "react";
import {useDetailHeroSummary} from "./DetailHeroSummaryContext";
import {useMobileFixedPageHero} from "../../hooks/useMobileFixedPageHero";
import "../layout/pageHeaderHero.css";

/** 수정·접수·등록 hero 요약 (탭 foot 없음) */
export function DetailFormHeroHeader() {
    const heroRef = useRef(null);
    useMobileFixedPageHero(heroRef);
    const heroSummary = useDetailHeroSummary();

    if (!heroSummary?.title) {
        return null;
    }

    return (
        <header ref={heroRef} className="page-header-hero detail-tab-bar-hero detail-form-hero">
            <div className="detail-tab-bar-hero__main detail-form-hero__main">
                <div className="detail-tab-bar-hero__title-row">
                    <h1 className="page-header-hero__title">{heroSummary.title}</h1>
                    {heroSummary.actions ? (
                        <div className="detail-tab-bar-hero__summary-actions asset-detail-summary-actions">
                            {heroSummary.actions}
                        </div>
                    ) : null}
                </div>
                {heroSummary.meta ? (
                    <p className="detail-tab-bar-hero__summary-meta">{heroSummary.meta}</p>
                ) : null}
            </div>
        </header>
    );
}
